import React from 'react';
import {
    Layout, Row, Col,  Button, message

} from 'antd';
import MiCompAPI from '../../util/api';

const { Content } = Layout;
class UploadCommession extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filedata: '',
            isLoading: true,
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }  

    handleAddDocument = async (evt) => {
        var f = evt.target.files[0];     
        this.setState({
            filedata: {
                base64file: await this.convertBase64(f),
                docName: f.name,
            }
        });
    }

    uploadFile = () => {
        if (this.state.filedata) {            
                this.api.invoke(
                    "Upload_Commission",
                    "post",
                    (data, success) => {

                        if (success) {
                            if (data.statusCode === 200) {
                                document.getElementById('files').value = "";
                                message.destroy();
                                message.success(data.statusMessage, 4);                                
                            } else {                                
                                message.destroy();
                                message.error(data.statusMessage, 4);
                            }
                        }
                    },
                    { client_id: this.props.client_id,filename:this.state.filedata.docName, base64: this.state.filedata.base64file });            
        } else {
            if(!this.state.filedata){
                message.destroy();
                message.error("Please select file to upload", 4);
            }          
        }
    }
    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div" style={{    marginLeft:"-30px",marginRight: "-29px"}}>  
                <div className="mi_main" style={{marginLeft:'10px',marginTop:"0px"}}>
                    <Row span={24} style={{ marginTop: '10px' }}>
                        <Col span={8}></Col>
                        <Col span={8}>
                            <input type="file" id="files" name="files" onChange={this.handleAddDocument} />
                        </Col>
                        <Col span={8}></Col>
                    </Row>
                    <Row span={24} style={{ marginTop: '30px' }}>
                        <Col span={8}></Col>
                        <Col span={8}>  
                            <Button type="primary" style={{ float: 'right' }} onClick={this.uploadFile}>
                                <i className="fa fa-upload" aria-hidden="true"></i>
                                Upload
                            </Button>
                        </Col>
                        <Col span={8}></Col>
                    </Row></div>
                </div>
            </Content>
        );
    }
}

export default UploadCommession;